import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';
import { GetShareBarReqProps } from '../../types/sharebarTypes';

export const VersionId = 'v1';
export const SHAREBAR_SERVICE_KEY = 'comsharebaras';

export const createSharebarReqObj: RequestOptions = {
  url: `/${SHAREBAR_SERVICE_KEY}/${VersionId}/sharecodes`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const getSharebarReqObj = ({ sharecode, sharecodeid, projections }: GetShareBarReqProps): RequestOptions => {
  const params: Record<string, string> = {
    projections: projections,
  };
  sharecode && (params['sharecode'] = sharecode);
  sharecodeid && (params['sharecodeid'] = sharecodeid);
  return {
    url: `/${SHAREBAR_SERVICE_KEY}/${VersionId}/sharecodes`,
    method: HTTPVerbs.GET,
    retries: 0,
    params,
  };
};

export const updateCustomSharecodeReqObj: RequestOptions = {
  url: `/${SHAREBAR_SERVICE_KEY}/${VersionId}/sharecodes`,
  method: HTTPVerbs.PUT,
  retries: 0,
};

export const getChannelConfig: RequestOptions = {
  url: `/${SHAREBAR_SERVICE_KEY}/${VersionId}/channelconfigs`,
  method: HTTPVerbs.GET,
  retries: 0,
};
